import Model        from "./Model";
import Logo         from "./Logo";

export default class Staff extends Model{

    constructor( options = {} ) {

        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} ) {
        this.id         = options.id              || null;
        this.name       = options.name            || null;
        this.lastName   = options.lastName        || null;
        this.displayName= options.displayName     || null;
        this.email      = options.email           || null;
        this.phone      = options.phone           || null;
        this.phoneClear = options.phoneClear      || null;
        this.avatar     = new Logo(options.avatar || {});
        this.position   = options.position      || null;
        this.web        = options.web             || null;
        this.twitter    = options.twitter         || null;
        this.skype      = options.skype           || null;
        this.linkedin   = options.linkedin        || null;
        this.facebook   = options.facebook        || null;
        this.instagram  = options.instagram       || null;
        this.createdAt  = options.createdAt       || null;
        this.updatedAt  = options.updatedAt       || null;
    }

    toJson (){

        return {
            'id'            : this.id                    ,
            'name'          : this.name                  ,
            'lastName'      : this.lastName              ,
            'displayName'   : this.displayName           ,
            'email'         : this.email                 ,
            'phone'         : this.phone                 ,
            'phoneClear'    : this.phoneClear            ,
            'position'      : this.position              ,
            'avatar'        : this.avatar.toJson()       ,
            'web'           : this.web                   ,
            'twitter'       : this.twitter               ,
            'skype'         : this.skype                 ,
            'linkedin'      : this.linkedin              ,
            'facebook'      : this.facebook              ,
            'instagram'     : this.instagram             ,
            'createdAt'     : this.createdAt             ,
            'updatedAt'     : this.updatedAt             ,
        }
    }


    static signUp(options){

        let url = '/rq/user/signup';

        return new Promise( function(resolve, reject) {

            axios.post(url, options).then(function (response) {

                resolve( new User(response.data.data) );

            }).catch(function(error){

                reject(error);
            });
        });
    }
}




// WEBPACK FOOTER //
// ./resources/js/models/Staff.js